<canvas ref="barWithLineChart"></canvas>
<script>
import { plugins } from "chart.js";
import { Bar } from "vue-chartjs";
import { ColorUtil } from '@/utils/colorUtil';

export default {
  name: "BarWithLineChart",
  extends: Bar,
  props: {
    title: {
      type: String,
      required: true,
    },
    barLabel: {
      type: String,
      required: true,
    },
    lineLabel: {
      type: String,
      required: true,
    },
    labels: {
      type: Array,
      required: true,
    },
    barData: {
      type: Array,
      required: true,
    },
    lineData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    // Re-render chart when any prop changes
    labels: "renderBarWithLineChart",
    barData: "renderBarWithLineChart",
    lineData: "renderBarWithLineChart",
  },
  mounted() {
    this.renderBarWithLineChart();
  },
  methods: {
    renderBarWithLineChart() {
      this.renderChart(
        {
          labels: this.labels,
          datasets: [
            {
              backgroundColor: ColorUtil.generateColors(this.barData.length),
              label: this.barLabel,
              type: "bar",
              data: this.barData,
              yAxisID: "y-axis-1",
            },
            {
              label: this.lineLabel,
              type: "line",
              data: this.lineData,
              fill: false,
              yAxisID: "y-axis-2",                
              backgroundColor: '#F3A8A5',
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          title: {
            display: false,
            text: this.title,
            fontSize: 18,
            fontColor: "#000",
          },
          legend: {
            labels: {
              boxWidth: 12,
              fontColor: "#000",
            },
          },
          scales: {
            yAxes: [
              {
                id: "y-axis-1",
                type: "linear",
                position: "left",
                ticks: {
                  beginAtZero: true,
                  suggestedMax: 50,
                },
                scaleLabel: {
                  display: this.barData ? true : false,
                  labelString: this.barLabel,
                },
              },
              {
                id: "y-axis-2",
                type: "linear",
                position: "right",
                ticks: {
                  beginAtZero: true,
                  suggestedMax: 50,
                },
                gridLines: {
                  drawOnChartArea: false,
                },
                scaleLabel: {
                  display: this.lineLabel ? true : false,
                  labelString: this.lineLabel,
                },
              },
            ],
            xAxes: [
              {
                stacked: false,
                gridLines: {
                  display: false,
                },
              },
            ],
          },
        }
      );
    },
  },
};
</script>

<style scoped>
canvas {
  height: 250px !important;
}
</style>
